import React, {useContext, useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DropdownContext } from '../../utils/constants';
import { formatCurrency } from '../../utils/currencyFormater';
import {SubsectionHeader} from "../Typography";
import {getData} from "../../utils/apiUtils";
import {useParams} from "react-router-dom";

const useStyles = makeStyles(() => ({
    container: {
        width: '100%'
    },
  gridContainer: {
    textTransform: 'uppercase',
    overflowX: 'auto',
    paddingTop: '1rem',
    paddingBottom: '1rem'
  },
  tableCell: {
    textAlign: 'center',
    verticalAlign: 'middle',
    border: '1px solid',
    padding: '1rem'
  },
  bolded: {
    fontWeight: '700'
  }
}));

export default function ValuesSummaryCard({ values, valuesChanged }) {
  const classes = useStyles();
  const { id: initiativeId } = useParams();

  const [valueMetrics, setValueMetrics] = useState({});
  const [performanceValueKey, setPerformanceValueKey] = useState(null);
  const [yearSummary, setYearSummary] = useState([]);
  const [totalValues, setTotalValues] = useState({
    year: 'Total',
    savings: 0,
    costs: 0
  });

  const {dropdowns} = useContext(DropdownContext);
  useEffect(() => {
    if (dropdowns) {
      setValueMetrics(dropdowns['ValueMetric'] || {});
      const types = dropdowns['ValueType'] || {};
      if (types) {
        Object.keys(types).forEach(key => {
          const dropdownValue = types[key];
          if (dropdownValue === 'Financial Metric')
            setPerformanceValueKey(parseInt(key));
        });
      }
    }
  }, [dropdowns]);

  const handleSummation = (myValues) => {
    if (performanceValueKey && valueMetrics) {
      const performanceValues = myValues.filter(item => item.valueTypeId === performanceValueKey);
      const yearValues = {};
      const totalValuesStruct = {
        year: 'Total',
        savings: 0,
        costs: 0
      };
      performanceValues.forEach(value => {
        const metricData = value.metricData;

        Object.keys(metricData).map(key => {
          const data = metricData[key];
          const metric = valueMetrics[value.metricId];
          let yearStruct = yearValues[key];
          if (!yearStruct) {
            yearStruct = {
              year: parseInt(key),
              savings: 0,
              costs: 0
            }
            yearValues[key] = yearStruct;
          }

          if (metric) {
            if (metric.substring(0, 19) === 'Implementation Cost' || metric.substring(0, 27) === 'Recurring Sustainment Costs') {
              yearStruct.costs += data.summation;
              totalValuesStruct.costs += data.summation;
            } else {
              yearStruct.savings += data.summation;
              totalValuesStruct.savings += data.summation;
            }
          }
        });
      });
      setYearSummary((Object.values(yearValues)).sort((a, b) => a.year - b.year));
      setTotalValues(totalValuesStruct);
    }
  }
  useEffect(() => {
    if (valuesChanged !== 0) {
      getData(`/initiatives/${initiativeId}/values`, (data) => {handleSummation(data.values)}, ()=> console.log('Error update table.'));
    }
  }, [valuesChanged]);

  useEffect(() => {
    handleSummation(values);
  }, [values, performanceValueKey, valueMetrics]);

  return (
    <div className={classes.container}>
      <SubsectionHeader style={{width: '100%'}}>
        Value Summary
      </SubsectionHeader>
      {yearSummary.length > 0 ?
        (
          <div className={classes.gridContainer}>
            <table style={{tableLayout: 'auto'}} className="MuiTable-root data-grid">
              <thead>
              <tr key="summary-header">
                <th className={classes.tableCell}></th>
                {yearSummary.map(year => <th className={classes.tableCell}
                                             key={`header-${year.year}`}>{year.year} </th>)}
                <th className={classes.tableCell}>Total</th>
              </tr>
              </thead>
              <tbody>
              <tr className="MuiTableRow-root" key={'summary-savings-row'}>
                <td className={`${classes.tableCell} ${classes.bolded}`}>Savings</td>
                {yearSummary.map(year => <td className={classes.tableCell}
                                             key={`savings-${year.year}`}>{formatCurrency(year.savings)} </td>)}
                <td className={`${classes.tableCell} ${classes.bolded}`}>{formatCurrency(totalValues.savings)}</td>
              </tr>
              <tr className="MuiTableRow-root" key={'summary-costs-row'}>
                <td className={`${classes.tableCell} ${classes.bolded}`}>Costs</td>
                {yearSummary.map(year => <td className={classes.tableCell}
                                             key={`costs-${year.year}`}>{formatCurrency(year.costs)} </td>)}
                <td className={`${classes.tableCell} ${classes.bolded}`}>{formatCurrency(totalValues.costs)}</td>
              </tr>
              <tr className="MuiTableRow-root" key={'summary-net-row'}>
                <td className={`${classes.tableCell} ${classes.bolded}`}>Net</td>
                {yearSummary.map(year => <td className={classes.tableCell}
                                             key={`net-${year.year}`}>{formatCurrency(year.savings - year.costs)} </td>)}
                <td
                  className={`${classes.tableCell} ${classes.bolded}`}>{formatCurrency(totalValues.savings - totalValues.costs)}</td>
              </tr>
              </tbody>
            </table>
          </div>
        ) : <h3>No performance value metrics</h3>
      }
    </div>
  );
}
